/* tslint:disable */
/* eslint-disable */
/**
 * compass-pro
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OrganizationAdminUpdateGroupName
 */
export interface OrganizationAdminUpdateGroupName {
    /**
     * 
     * @type {string}
     * @memberof OrganizationAdminUpdateGroupName
     */
    org_code: string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationAdminUpdateGroupName
     */
    old_group_name: string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationAdminUpdateGroupName
     */
    new_group_name: string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationAdminUpdateGroupName
     */
    organization_azure_id: string;
}

/**
 * Check if a given object implements the OrganizationAdminUpdateGroupName interface.
 */
export function instanceOfOrganizationAdminUpdateGroupName(value: object): value is OrganizationAdminUpdateGroupName {
    if (!('org_code' in value) || value['org_code'] === undefined) return false;
    if (!('old_group_name' in value) || value['old_group_name'] === undefined) return false;
    if (!('new_group_name' in value) || value['new_group_name'] === undefined) return false;
    if (!('organization_azure_id' in value) || value['organization_azure_id'] === undefined) return false;
    return true;
}

export function OrganizationAdminUpdateGroupNameFromJSON(json: any): OrganizationAdminUpdateGroupName {
    return OrganizationAdminUpdateGroupNameFromJSONTyped(json, false);
}

export function OrganizationAdminUpdateGroupNameFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrganizationAdminUpdateGroupName {
    if (json == null) {
        return json;
    }
    return {
        
        'org_code': json['org_code'],
        'old_group_name': json['old_group_name'],
        'new_group_name': json['new_group_name'],
        'organization_azure_id': json['organization_azure_id'],
    };
}

export function OrganizationAdminUpdateGroupNameToJSON(json: any): OrganizationAdminUpdateGroupName {
    return OrganizationAdminUpdateGroupNameToJSONTyped(json, false);
}

export function OrganizationAdminUpdateGroupNameToJSONTyped(value?: OrganizationAdminUpdateGroupName | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'org_code': value['org_code'],
        'old_group_name': value['old_group_name'],
        'new_group_name': value['new_group_name'],
        'organization_azure_id': value['organization_azure_id'],
    };
}

